/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The RestBodyResponseUtil model module.
 * @module model/RestBodyResponseUtil
 * @version v0
 */
export class RestBodyResponseUtil {
  /**
   * Constructs a new <code>RestBodyResponseUtil</code>.
   * @alias module:model/RestBodyResponseUtil
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>RestBodyResponseUtil</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RestBodyResponseUtil} obj Optional instance to populate.
   * @return {module:model/RestBodyResponseUtil} The populated <code>RestBodyResponseUtil</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new RestBodyResponseUtil();
      if (data.hasOwnProperty('timestamp'))
        obj.timestamp = ApiClient.convertToType(data['timestamp'], 'Date');
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'Number');
      if (data.hasOwnProperty('error'))
        obj.error = ApiClient.convertToType(data['error'], 'String');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('path'))
        obj.path = ApiClient.convertToType(data['path'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Date} timestamp
 */
RestBodyResponseUtil.prototype.timestamp = undefined;

/**
 * @member {Number} status
 */
RestBodyResponseUtil.prototype.status = undefined;

/**
 * @member {String} error
 */
RestBodyResponseUtil.prototype.error = undefined;

/**
 * @member {String} message
 */
RestBodyResponseUtil.prototype.message = undefined;

/**
 * @member {String} path
 */
RestBodyResponseUtil.prototype.path = undefined;

